import type { SavedDrawing } from '@/workspace/types'
import type { ChartDrawingsStore } from '../chart-assets-store'

/**
 * What each companion drawing call changed, keyed by its tool_use_id, so the
 * Keep/Undo banner (action-snapshot.ts) reverses exactly that call: a draw's
 * Undo removes the drawings it added, a clear's Undo puts back what it
 * removed. The drawing ids are only known once the call has run, after the
 * snapshot was taken, hence this record. Plain module state, bounded.
 */
export interface AiDrawingBatch {
  store: ChartDrawingsStore
  ticker: string
  added: SavedDrawing[]
  removed: SavedDrawing[]
}

const MAX_BATCHES = 50
const batches = new Map<string, AiDrawingBatch>()

export function recordAiDrawingBatch(toolUseId: string, batch: AiDrawingBatch): void {
  batches.set(toolUseId, batch)
  while (batches.size > MAX_BATCHES) batches.delete(batches.keys().next().value as string)
}

/** Reverse one call's drawing changes; false when there is nothing recorded for it. */
export function revertAiDrawingBatch(toolUseId: string): boolean {
  const batch = batches.get(toolUseId)
  if (!batch) return false
  batches.delete(toolUseId)
  batch.store
    .getState()
    .applyEdits(batch.ticker, [
      ...batch.added.map((d) => ({ syncId: d.syncId, to: null })),
      ...batch.removed.map((d) => ({ syncId: d.syncId, to: d })),
    ])
  return true
}

/** Test seam. */
export function resetAiDrawingBatches(): void {
  batches.clear()
}
